import React, { useCallback, useEffect, useMemo, useRef } from 'react';

import { downloadSettingExcel } from "src/utils/blob/blobUtil";

import { defaultWMS1021_R01Filter, WMS1021_R01Filter, useWMS1021_R01Store } from 'src/containers/mes/WMS/WMS1021_R01/Store_WMS1021_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { deleteWMS1021_R01, downloadExcel_WMS1021_R01, getWMS1021_R01AllCount, getWMS1021_R01DetailList, getWMS1021_R01List, getWMS1021_R01One, getWMS1021_R01TransportHeader, getWMS1021_R01WmsTransport, patchWMS1021_R01, postWMS1021_R01, createWMS1021_R01LotNo } from "./Api_WMS1021_R01";
import { defaultWMS1021_R01DetailDto, defaultWMS1021_R01HeaderDto, defaultWMS1021_R01LotDto, WMS1021_R01DetailDto, WMS1021_R01Dto, WMS1021_R01HeaderDto, WMS1021_R01LotDto } from './Dto_WMS1021_R01';
import { AgGridReact } from 'ag-grid-react';
import { gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { formatDate, validateString } from 'src/utils/string/stringUtil';
import { validateCustomCd } from 'src/utils/grid/GridValidateContent';
import { useCommonCodeValidate } from 'src/utils/commonCode/CommonCodeValidateContext';
import {
	buildCommonCodeRequirements,
	WMS1021_R01_HEADER_ROW_VALIDATE,
} from 'src/utils/commonCode/commonCodeRequirementConfig';
import { useItemQzPrint } from 'src/hooks/useItemQzPrint';
import { getDefaultLabelPrintAuto } from 'src/utils/label/labelPrintAutoProgramUtil';
import { WMS1021_R01_extractUnprintedItemLabelData } from './labelDataBuilder_WMS1021_R01';
import { ItemLabelPrintData } from 'src/apis/itemLabelApi';


interface Props {
	gridRef: React.RefObject<AgGridReact<WMS1021_R01HeaderDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<WMS1021_R01DetailDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
}

export const Content_WMS1021_R01 = (props: Props) => {
	const { printBulkItemLabel } = useItemQzPrint();

	const {
		gridRef, detailGridRef,
		tabList, setMessage,
	} = props;

	const {
		WMS1021_R01Filter, setWMS1021_R01Filter,
		WMS1021_R01PastFilter, setWMS1021_R01PastFilter,
		WMS1021_R01List, setWMS1021_R01List,
		editWMS1021_R01, setEditWMS1021_R01,
		selectedWMS1021_R01, setSelectedWMS1021_R01,
		deletedWMS1021_R01DetailList, setDeletedWMS1021_R01DetailList, addDeletedWMS1021_R01DetailList, removeDeletedWMS1021_R01DetailList,
		selectedWMS1021_R01DetailList, setSelectedWMS1021_R01DetailList, removeSelectedWMS1021_R01DetailList,
		WMS1021_R01DetailList, setWMS1021_R01DetailList,
		originalWMS1021_R01DetailList, setOriginalWMS1021_R01DetailList,
		allCount, setAllCount,
		transportComplete, setTransportComplete,
		detailFetchTrigger, setDetailFetchTrigger,
		initData,
		warehouseCdListToUseList,
		setScrollTop, setDetailScrollTop,
		setAutoTransportQtyIfEmpty,
	} = useWMS1021_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();
	const { inoutClassList, inoutTypeList, inoutMethodList, wmsCdList, wmsInTypeCdList, compCdList, customCdList, warehouseCdList, programList } = useCommonCodeStore();

	const defaultLabelPrintAuto = useMemo(
		() => getDefaultLabelPrintAuto(programList),
		[programList]
	);

	useFetchActionbarAuth("WMS1021_R01");

	const prevWmsOrderNoRef = useRef<string | undefined>(undefined);

	const handleExcelClick = useCallback(async () => {
		if (!selectedWMS1021_R01) {
			showWarning("선택된 입고정보내역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const response = await downloadExcel_WMS1021_R01('', selectedWMS1021_R01.wmsOrderNo, selectedWMS1021_R01.warehouseCd, WMS1021_R01List.length ?? 0);

		downloadSettingExcel({ responseData: response.data.data, fileName: '입고정보 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [selectedWMS1021_R01, WMS1021_R01List.length, setLoadingSpinner]);

	const getParams = (filter: WMS1021_R01Filter) => {
		const params: Partial<WMS1021_R01Filter> = {
			dateRange: filter.dateRange || undefined,
			wmsOrderNo: filter.wmsOrderNo || undefined,
			customCd: filter.customCd || undefined,
		};
		return params;
	};

	const renewalAllCount = useCallback(async () => {
		const response = await getWMS1021_R01AllCount(getParams(WMS1021_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [WMS1021_R01Filter, setAllCount]);

	const fetchData = useCallback(async () => {
		setLoadingSpinner(true);
		setScrollTop(null);
		setDetailScrollTop(null);

		const responseData = await getWMS1021_R01List(
			'',
			getParams(WMS1021_R01Filter),
			WMS1021_R01List.length ?? 0
		);

		const newList = [...responseData.data.data] as WMS1021_R01HeaderDto[];
		setWMS1021_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedWMS1021_R01,
				() => true,
			);
			setWMS1021_R01PastFilter(WMS1021_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
			setTimeout(() => setMessage(""), 5000);
		} else {
			showWarning('데이터가 없습니다.');
			setSelectedWMS1021_R01(defaultWMS1021_R01HeaderDto);
			setWMS1021_R01List([]);
			setWMS1021_R01DetailList([]);
			setDeletedWMS1021_R01DetailList([]);
			setSelectedWMS1021_R01DetailList([]);
			setOriginalWMS1021_R01DetailList([]);
		}
		setLoadingSpinner(false);
		return responseData;
	}, [
		WMS1021_R01Filter, WMS1021_R01List, setWMS1021_R01List, setWMS1021_R01PastFilter,
		setSelectedWMS1021_R01, setScrollTop, setDetailScrollTop, setLoadingSpinner,
		setMessage, setWMS1021_R01DetailList, setDeletedWMS1021_R01DetailList,
		setSelectedWMS1021_R01DetailList, setOriginalWMS1021_R01DetailList, gridRef, renewalAllCount,
	]);

	const fetchOne = useCallback(async () => {
		if (!selectedWMS1021_R01) return;

		const response = await getWMS1021_R01One(selectedWMS1021_R01.wmsOrderNo);

		return response.data.data as WMS1021_R01HeaderDto;
	}, [selectedWMS1021_R01]);

	const defaultWMS1021_R01HeaderRow = useCallback(() => {
		const logicCenter = wmsCdList[0]?.minorCd ?? '';
		const warehouseCdListToUse = warehouseCdList.filter(value =>
			value.logicCenter === logicCenter && value.materialYn === 'Y'
		);

		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(WMS1021_R01_HEADER_ROW_VALIDATE, {
				compCdList,
				inoutClassList,
				inoutMethodList,
				inoutTypeList,
				wmsCdList,
				warehouseCdList: warehouseCdListToUse,
			}),
		);
		if (!commonResult.valid) {
			return { ...defaultWMS1021_R01HeaderDto };
		}

		return {
			...defaultWMS1021_R01HeaderDto,
			compCd: compCdList[0].compCd,
			inoutClass: inoutClassList.find(value => value.minorCd === '110')?.minorCd || '',
			inoutType: inoutTypeList.find(value => value.minorCd === 'IN')?.minorCd || '',
			logicCenter,
			warehouseCd: warehouseCdListToUse[0].warehouseCd,
			inoutMethod: inoutMethodList[0].minorCd,
			inserted: true,
		};
	}, [
		compCdList, wmsCdList, warehouseCdList,
		inoutMethodList, inoutClassList, inoutTypeList, validateCommonCodeLists,
	]);

	const defaultWMS1021_R01DetailRow = useCallback(() => ({
		...defaultWMS1021_R01DetailDto,
		inserted: true,
	}), []);

	const fetchTransportHeader = useCallback(async () => {
		if (!selectedWMS1021_R01) return;

		const response = await getWMS1021_R01TransportHeader(selectedWMS1021_R01.wmsOrderNo);

		return response.data.data as WMS1021_R01HeaderDto;
	}, [selectedWMS1021_R01]);

	const initContainerData = useCallback(() => {
		initData();
		setWMS1021_R01Filter({ labelPrintAuto: defaultLabelPrintAuto });
		removeDeletedWMS1021_R01DetailList();
		removeSelectedWMS1021_R01DetailList();
		setEditWMS1021_R01({ ...defaultWMS1021_R01HeaderRow() });
	}, [initData, defaultLabelPrintAuto, setWMS1021_R01Filter, removeDeletedWMS1021_R01DetailList, removeSelectedWMS1021_R01DetailList, setEditWMS1021_R01, defaultWMS1021_R01HeaderRow]);

	const handleDeleteClick = useCallback(() => {
		if (deletedWMS1021_R01DetailList.length > 0) {
			removeDeletedWMS1021_R01DetailList(deletedWMS1021_R01DetailList);
			removeSelectedWMS1021_R01DetailList();
			setWMS1021_R01DetailList([...WMS1021_R01DetailList]);
		} else if (selectedWMS1021_R01DetailList.length > 0) {
			addDeletedWMS1021_R01DetailList(selectedWMS1021_R01DetailList);
			removeSelectedWMS1021_R01DetailList(selectedWMS1021_R01DetailList);
		}
	}, [
		selectedWMS1021_R01DetailList,
		deletedWMS1021_R01DetailList,
		addDeletedWMS1021_R01DetailList,
		removeDeletedWMS1021_R01DetailList,
		removeSelectedWMS1021_R01DetailList,
		setWMS1021_R01DetailList,
		WMS1021_R01DetailList,
	]);

	const handleCreateClick = () => {
		setSelectedWMS1021_R01(undefined);
		setEditWMS1021_R01({ ...defaultWMS1021_R01HeaderRow() });
		setWMS1021_R01DetailList([{ ...defaultWMS1021_R01DetailRow(), inserted: true }]);
		setDeletedWMS1021_R01DetailList([]);
		setSelectedWMS1021_R01DetailList([]);
		setOriginalWMS1021_R01DetailList([]);
	};

	const validateInsertData = (header: WMS1021_R01HeaderDto, detailList: WMS1021_R01DetailDto[]) => {
		if (!validateString(header.wmsOrderNo)) {
			showWarning('입고지시항목을 선택해서 저장해주세요.'); return false;
		}
		if (!validateString(header.compCd)) {
			showWarning('사업장을 선택해주세요.'); return false;
		}
		if (!validateString(header.customCd)) {
			showWarning('거래처를 입력해주세요.'); return false;
		}
		if (!validateCustomCd(header.customCd, customCdList)) {
			showWarning('거래처가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}
		if (!validateString(header.logicCenter)) {
			showWarning('물류센터를 선택해주세요.'); return false;
		}
		if (!validateString(header.warehouseCd)) {
			showWarning('창고번호를 선택해주세요.'); return false;
		}
		if (!validateString(header.inoutMethod)) {
			showWarning('입고구분을 선택해주세요.'); return false;
		}

		if (detailList.length === 0) {
			showWarning('상세내역을 입력해주세요.'); return false;
		}

		const itemStatusPairs = new Set<string>();
		for (const item of detailList) {
			if (!validateString(item.itemCd)) {
				showWarning('품목코드를 입력해주세요.'); return false;
			}
			if (!validateString(item.itemStatus)) {
				showWarning('품목의 상태를 선택해주세요.'); return false;
			}
			if (item.orderQty <= 0) {
				showWarning('수량을 입력해주세요.'); return false;
			}

			const pair = `${item.itemCd}-${item.itemStatus}`;
			if (itemStatusPairs.has(pair)) {
				showWarning(`품목코드 '${item.itemCd}'와(과) 품목상태 '${item.itemStatus}'의 조합이 중복되었습니다.`);
				return false;
			}
			itemStatusPairs.add(pair);

			if (item.orderQty < item.transportQty + item.updateTransportQty) {
				showWarning(`입고량이 주문잔량보다 클 수 없습니다. - 품목코드: ${item.itemCd}, 품목상태: ${item.itemStatus}`); return false;
			}
		}

		return true;
	};

	const setInfoDetailList = useCallback((header: WMS1021_R01HeaderDto, detailList: WMS1021_R01DetailDto[]) => {
		return detailList.map((value) => ({
			...value,
			compCd: header.compCd,
			customCd: header.customCd,
		}));
	}, []);

	const refetchResponseDetailList = useCallback((responseData: WMS1021_R01Dto) => {
		let detailDtoList = responseData.wmsOrderDetailDtoList;

		detailDtoList = detailDtoList.map(value => ({
			...value,
			orderQtyView: value.orderQty - value.transportQty - value.updateTransportQty - value.cancelQty,
		}));

		detailDtoList = detailDtoList.filter(value => value.orderQtyView > 0);
		responseData.wmsOrderDetailDtoList = detailDtoList;

		return responseData;
	}, []);

	const buildLotMapFromDetails = useCallback((
		header: WMS1021_R01HeaderDto,
		detailList: WMS1021_R01DetailDto[],
		deletedValueIndexes: number[],
	): Map<string, WMS1021_R01LotDto[]> => {
		const lotMap = new Map<string, WMS1021_R01LotDto[]>();

		detailList
			.filter(detail =>
				!deletedValueIndexes.includes(detail.valueIndex)
				&& detail.updateTransportQty > 0
			)
			.forEach(detail => {
				lotMap.set(detail.itemCd, [{
					...defaultWMS1021_R01LotDto,
					valueIndex: detail.valueIndex,
					orderIndex: detail.orderIndex,
					orderIndexSeq: detail.orderIndexSeq,
					warehouseCd: header.warehouseCd,
					warehouseNm: header.warehouseNm,
					itemCd: detail.itemCd,
					itemNm: detail.itemNm,
					itemSpec: detail.itemSpec,
					itemUnit: detail.orderUnit,
					itemStatus: detail.itemStatus,
					lotQty: detail.updateTransportQty,
					transportNo: header.wmsOrderNo,
					itemNo: detail.itemNo,
					lotInputOption: 'N',
					printed: false,
					inserted: true,
				}]);
			});

		return lotMap;
	}, []);

	const setInfoLotList = useCallback((lotMap: Map<string, WMS1021_R01LotDto[]>): Record<string, WMS1021_R01LotDto[]> => {
		const filteredLotMap: Record<string, WMS1021_R01LotDto[]> = {};

		lotMap.forEach((lots, itemCd) => {
			const filteredLots = lots.filter(lot => lot.lotQty && lot.lotQty > 0 && lot.inserted === true);
			if (filteredLots.length > 0) {
				filteredLotMap[itemCd] = filteredLots;
			}
		});

		return filteredLotMap;
	}, []);

	const assignLotNoToMaps = useCallback(async (currentLotMap: Map<string, WMS1021_R01LotDto[]>) => {
		const newLotMap = new Map<string, WMS1021_R01LotDto[]>();
		const promises: Promise<void>[] = [];

		for (const [itemCd, lots] of Array.from(currentLotMap.entries())) {
			const newLots = lots.map(lot => ({ ...lot }));

			newLots.forEach((lot) => {
				if (!validateString(lot.lotNo)) {
					const promise = createWMS1021_R01LotNo().then((res) => {
						if (res.data && res.data.successFlag) {
							lot.lotNo = res.data.data;
						}
					});
					promises.push(promise);
				}
			});
			newLotMap.set(itemCd, newLots);
		}

		if (promises.length > 0) {
			await Promise.all(promises);
		}

		return newLotMap;
	}, []);

	const handleSaveClick = useCallback(async () => {
		if (!validateInsertData(editWMS1021_R01!, WMS1021_R01DetailList)) return;

		setLoadingSpinner(true);

		const deletedWMS1021_R01DetailList_Number = deletedWMS1021_R01DetailList.map(value => Number(value));

		// 저장 전 품목 라벨 데이터 추출 (Lot라벨자동출력=Y일 때만). 저장 완료 후 일괄 출력
		let unprintedItemLabelData: ItemLabelPrintData[] = [];
		if (WMS1021_R01Filter.labelPrintAuto === 'Y') {
			unprintedItemLabelData = WMS1021_R01_extractUnprintedItemLabelData(
				editWMS1021_R01!,
				WMS1021_R01DetailList,
				deletedWMS1021_R01DetailList_Number,
			);
		}

		const lotMapFromDetails = buildLotMapFromDetails(
			editWMS1021_R01!,
			WMS1021_R01DetailList,
			deletedWMS1021_R01DetailList_Number,
		);
		const newLotMap = await assignLotNoToMaps(lotMapFromDetails);
		const lotMapObject = setInfoLotList(newLotMap);

		let processName = '';
		let newDetailList: WMS1021_R01DetailDto[] = [];
		let newHeaderList: WMS1021_R01HeaderDto[] = [];
		let responseData: WMS1021_R01Dto = {
			wmsOrderHeaderDto: editWMS1021_R01!,
			wmsOrderDetailDtoList: WMS1021_R01DetailList,
			wmsStockLotDtoList: lotMapObject,
		};

		if (selectedWMS1021_R01 && selectedWMS1021_R01.wmsOrderNo !== '') {
			newDetailList = WMS1021_R01DetailList
				.map(value => ({
					...value,
					transportQty: value.transportQty + value.updateTransportQty,
				}))
				.filter(value =>
					!deletedWMS1021_R01DetailList_Number.includes(value.valueIndex)
				);

			if (newDetailList.length === 0) {
				processName = 'delete';
				const deleteResponse = await deleteWMS1021_R01(selectedWMS1021_R01.wmsOrderNo);

				if (!deleteResponse || !deleteResponse.data.successFlag) { setLoadingSpinner(false); return; }

				newHeaderList = WMS1021_R01List.filter(value => value.wmsOrderNo !== selectedWMS1021_R01.wmsOrderNo);

				if (deleteResponse.data.successFlag) {
					showSuccess('입고내역이 삭제 되었습니다.');
					setMessage('입고내역이 삭제 되었습니다.');
				} else return;
			} else {
				processName = 'patch';
				const patchResponse = await patchWMS1021_R01({
					wmsOrderHeaderDto: editWMS1021_R01!,
					wmsOrderDetailDtoList: setInfoDetailList(editWMS1021_R01!, newDetailList),
					wmsStockLotDtoList: lotMapObject,
				});

				if (!patchResponse || !patchResponse.data.successFlag) { setLoadingSpinner(false); return; }

				responseData = patchResponse.data.data[0];
				responseData = refetchResponseDetailList(responseData);

				if (editWMS1021_R01!.closeTag === 'Y') {
					newHeaderList = WMS1021_R01List.filter(value => value.wmsOrderNo !== editWMS1021_R01!.wmsOrderNo);
				} else {
					newHeaderList = WMS1021_R01List.map(value => {
						if (value.wmsOrderNo === responseData.wmsOrderHeaderDto.wmsOrderNo) {
							return responseData.wmsOrderHeaderDto;
						}
						return value;
					});
				}

				if (patchResponse?.data?.data?.[0] && patchResponse.data.successFlag) {
					showSuccess('입고내역이 등록 되었습니다.');
					setMessage('입고내역이 등록 되었습니다.');
				}
			}
		} else {
			processName = 'post';
			const postResponse = await postWMS1021_R01({
				wmsOrderHeaderDto: editWMS1021_R01!,
				wmsOrderDetailDtoList: setInfoDetailList(editWMS1021_R01!, WMS1021_R01DetailList),
				wmsStockLotDtoList: lotMapObject,
			});

			if (!postResponse || !postResponse.data.successFlag) { setLoadingSpinner(false); return; }

			responseData = postResponse.data.data[0];
			responseData = refetchResponseDetailList(responseData);

			newHeaderList = [
				...WMS1021_R01List,
				responseData.wmsOrderHeaderDto,
			] as WMS1021_R01HeaderDto[];

			if (postResponse?.data?.data?.[0] && postResponse.data.successFlag) {
				showSuccess('입고내역이 등록 되었습니다.');
				setMessage('입고내역이 등록 되었습니다.');
			}
		}

		if (processName === 'delete') {
			setWMS1021_R01List(newHeaderList);
			setSelectedWMS1021_R01(undefined);
			setWMS1021_R01DetailList([]);
		} else if (processName === 'patch' || processName === 'post') {
			setWMS1021_R01List(newHeaderList);
			setWMS1021_R01DetailList(responseData.wmsOrderDetailDtoList);

			if (responseData.wmsOrderHeaderDto!.closeTag === 'Y') {
				setWMS1021_R01List(newHeaderList.filter(value => value.wmsOrderNo !== editWMS1021_R01!.wmsOrderNo));
				setSelectedWMS1021_R01(undefined);
				setEditWMS1021_R01({ ...defaultWMS1021_R01HeaderRow() });
				setWMS1021_R01DetailList([]);
				setOriginalWMS1021_R01DetailList([]);
				setSelectedWMS1021_R01DetailList([]);
			} else {
				setSelectedWMS1021_R01(responseData.wmsOrderHeaderDto);
				setSelectedWMS1021_R01DetailList([1 as any]);
				setOriginalWMS1021_R01DetailList(responseData.wmsOrderDetailDtoList);
			}
		}

		setDeletedWMS1021_R01DetailList([]);
		setTimeout(() => setMessage(''), 5000);
		setLoadingSpinner(false);

		// 저장 완료 후 품목 라벨 일괄 출력 (Lot라벨자동출력=Y, 삭제가 아닐 때만)
		if (
			WMS1021_R01Filter.labelPrintAuto === 'Y' &&
			unprintedItemLabelData.length > 0 &&
			processName !== 'delete'
		) {
			try {
				const ok = await printBulkItemLabel(unprintedItemLabelData);
				if (ok) {
					showSuccess(`저장 완료! ${unprintedItemLabelData.length}개 라벨 출력`);
				} else {
					showWarning('저장은 완료되었으나 라벨 출력에 실패했습니다. 프린터 설정을 확인해주세요.');
				}
			} catch (error: unknown) {
				const message = error instanceof Error ? error.message : '알 수 없는 오류';
				console.error('품목 라벨 출력 실패:', error);
				showWarning(`저장은 완료되었으나 라벨 출력에 실패했습니다: ${message}`);
			}
		}
	}, [
		WMS1021_R01Filter,
		editWMS1021_R01,
		selectedWMS1021_R01,
		WMS1021_R01DetailList,
		deletedWMS1021_R01DetailList,
		WMS1021_R01List,
		setWMS1021_R01List,
		setLoadingSpinner,
		setMessage,
		setInfoDetailList,
		refetchResponseDetailList,
		defaultWMS1021_R01HeaderRow,
		setEditWMS1021_R01,
		setOriginalWMS1021_R01DetailList,
		setSelectedWMS1021_R01,
		setSelectedWMS1021_R01DetailList,
		setWMS1021_R01DetailList,
		setDeletedWMS1021_R01DetailList,
		customCdList,
		buildLotMapFromDetails,
		assignLotNoToMaps,
		setInfoLotList,
		printBulkItemLabel,
	]);

	const handleDetailInfoCode = useCallback((headerData: WMS1021_R01HeaderDto): Partial<WMS1021_R01HeaderDto> => {
		const defaults: Partial<WMS1021_R01HeaderDto> = {};

		defaults.orderDt = formatDate(new Date());

		if (!validateString(headerData.compCd) && compCdList.length > 0) defaults.compCd = compCdList[0].compCd;
		if (!validateString(headerData.inoutMethod) && inoutMethodList.length > 0) defaults.inoutMethod = inoutMethodList[0].minorCd;

		if (!validateString(headerData.logicCenter) && wmsCdList.length > 0) {
			defaults.logicCenter = wmsCdList[0].minorCd;
		}
		defaults.logicCenter = headerData.logicCenter ? headerData.logicCenter : defaults.logicCenter;

		const warehouseCdListToUse = warehouseCdListToUseList(defaults.logicCenter || '');
		if (!validateString(headerData.warehouseCd) && warehouseCdListToUse.length > 0) {
			defaults.warehouseCd = warehouseCdListToUse[0].warehouseCd;
		}
		defaults.warehouseCd = headerData.warehouseCd ? headerData.warehouseCd : defaults.warehouseCd;

		if (!validateString(headerData.inoutClass) && wmsInTypeCdList.length > 0) defaults.inoutClass = wmsInTypeCdList[0].minorCd;
		defaults.inoutClass = validateString(headerData.inoutClass) ? headerData.inoutClass : defaults.inoutClass;

		return defaults;
	}, [inoutMethodList, wmsCdList, compCdList, warehouseCdListToUseList, wmsInTypeCdList]);

	const handleFetchDetailList = useCallback(async (wmsOrderNo: string, warehouseCd: string, isNewSelection: boolean) => {
		setLoadingSpinner(true);
		if (!warehouseCd) {
			showError('발주 정보의 물류정보의 조건에 맞는 창고 코드를 찾을 수 없어 입고 목록 내역을 조회할 수 없습니다.', 5000);
			setWMS1021_R01DetailList([]);
			setLoadingSpinner(false);
			return;
		}
		if (!isNewSelection) { setLoadingSpinner(false); return; }

		try {
			const detailResponse = await getWMS1021_R01DetailList(wmsOrderNo, warehouseCd);
			const detailData = detailResponse.data.data;

			if (detailData && detailData.length > 0) {
				const updatedDetails = detailData.map((value) => ({
					...value,
					valueIndex: value.valueIndex,
					orderIndex: value.orderIndex,
					orderIndexSeq: value.orderIndexSeq,
					orderPrice: value.orderPrice,
					orderQtyView: value.orderQty - value.transportQty - value.cancelQty,
					updateTransportQty: 0,
				}));
				setWMS1021_R01DetailList(updatedDetails);
				setOriginalWMS1021_R01DetailList(detailData);
				setMessage(`${selectedWMS1021_R01?.compNm}의 입고지시내역 ${detailData.length}건을 조회하였습니다.`);
				setTimeout(() => setMessage(""), 5000);
				setSelectedWMS1021_R01DetailList([1 as any]);
				const firstDetail = useWMS1021_R01Store.getState().WMS1021_R01DetailList[0];
				if (firstDetail) setAutoTransportQtyIfEmpty(firstDetail);
			} else {
				showError('상세내역이 없습니다.');
				setWMS1021_R01DetailList([]);
			}
		} catch (error) {
			console.error("상세 내역 조회 실패:", error);
			showError('상세 내역을 조회하는 중 오류가 발생했습니다.');
			setWMS1021_R01DetailList([]);
		}
		setLoadingSpinner(false);
	}, [
		setMessage,
		setWMS1021_R01DetailList,
		setOriginalWMS1021_R01DetailList,
		selectedWMS1021_R01?.compNm,
		setSelectedWMS1021_R01DetailList,
		setLoadingSpinner,
		setAutoTransportQtyIfEmpty,
	]);

	useEffect(() => {
		if (!detailFetchTrigger) return;
		const fetchAllDetailsForSelectedRow = async () => {
			if (!selectedWMS1021_R01 || !selectedWMS1021_R01.wmsOrderNo) {
				if (!selectedWMS1021_R01) {
					setWMS1021_R01DetailList([]);
					setOriginalWMS1021_R01DetailList([]);
				}
				prevWmsOrderNoRef.current = undefined;
				return;
			}

			const previousOrderNo = prevWmsOrderNoRef.current;
			const currentOrderNo = selectedWMS1021_R01.wmsOrderNo;
			const isNewSelection = previousOrderNo !== currentOrderNo;

			const headerData = await fetchOne();

			const apiHeaderData = await fetchTransportHeader();
			if (apiHeaderData) setTransportComplete(true);
			else setTransportComplete(false);

			const baseDataForDefaults = { ...defaultWMS1021_R01HeaderRow(), ...headerData, ...(apiHeaderData || {}) };
			const defaultValues = handleDetailInfoCode(baseDataForDefaults);

			const logicCenterToUse = baseDataForDefaults.logicCenter || defaultValues.logicCenter || '';
			const warehouseCdToUse = baseDataForDefaults.warehouseCd || defaultValues.warehouseCd || '';

			setEditWMS1021_R01({
				...defaultWMS1021_R01HeaderRow(),
				...headerData,
				...defaultValues,
				logicCenter: logicCenterToUse,
				warehouseCd: warehouseCdToUse,
			});

			handleFetchDetailList(selectedWMS1021_R01.wmsOrderNo, warehouseCdToUse, isNewSelection);
			prevWmsOrderNoRef.current = selectedWMS1021_R01.wmsOrderNo;
			setDetailFetchTrigger(false);
		};

		fetchAllDetailsForSelectedRow();
	}, [
		selectedWMS1021_R01,
		detailFetchTrigger,
		setEditWMS1021_R01,
		setDetailFetchTrigger,
		fetchOne,
		fetchTransportHeader,
		handleDetailInfoCode,
		defaultWMS1021_R01HeaderRow,
		handleFetchDetailList,
		setTransportComplete,
		setWMS1021_R01DetailList,
		setOriginalWMS1021_R01DetailList,
	]);

	useEffect(() => {
		const checkWmsTransport = async () => {
			setLoadingSpinner(true);
			if (!editWMS1021_R01?.wmsOrderNo) {
				setTransportComplete(false);
				setLoadingSpinner(false);
				return;
			}

			const response = await getWMS1021_R01WmsTransport(editWMS1021_R01?.wmsOrderNo || '');
			if (
				response.data.data &&
				response.data.data.transportNo !== null && response.data.data.transportNo !== '') {
				setTransportComplete(true);
			} else {
				setTransportComplete(false);
			}
			setLoadingSpinner(false);
		};

		checkWmsTransport();
	}, [selectedWMS1021_R01, editWMS1021_R01?.wmsOrderNo, setLoadingSpinner, setTransportComplete]);

	useEffect(() => {
		setWMS1021_R01Filter({ labelPrintAuto: defaultLabelPrintAuto });
	}, [defaultLabelPrintAuto, setWMS1021_R01Filter]);

	return {
		handleExcelClick,
		fetchData,
		defaultWMS1021_R01HeaderRow,
		defaultWMS1021_R01DetailRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
		warehouseCdListToUseList,
		handleDetailInfoCode,
		handleFetchDetailList,
	};
};
